import 'zone.js'; // for angular subApps. All apps share same version
import '@angular/localize/init'
import 'keycloak-js';
import {defineCustomElements} from 'ohp-components/loader';
import {Application} from './components/Application';

defineCustomElements();

Application.init();
